<template>
  <div
    v-if="resultado.filas.length > 0"
    :class="maxHeight ? 'max-h-[60vh] overflow-auto' : 'overflow-auto'"
  >
    <DataTable
      :key="tablaKey"
      :options="tabla"
    />
  </div>
  <div
    v-else
    class="py-10 text-center text-sm text-gray-500 dark:text-gray-400"
  >
    Sin información disponible
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import type { IDataTable } from '@/modules/Core/interfaces'
import type { IListaSqlFila, IListaSqlResultado } from '@/modules/Configuracion/interfaces'

const props = withDefaults(defineProps<{
  resultado: IListaSqlResultado
  identification: string
  maxHeight?: boolean
}>(), {
  maxHeight: false
})

const tablaKey = ref(0)
const tabla = ref<IDataTable<IListaSqlFila>>({
  identification: props.identification,
  title: '',
  noTitle: true,
  showHeader: true,
  noPagination: true,
  isList: true,
  search: async () => props.resultado.filas,
  columns: [],
  rows: [],
  pag: 1,
  count: 0,
  countPag: 0,
  limit: 1,
  loading: false,
  filtros: []
})

watch(
  () => props.resultado,
  resultado => {
    tabla.value.columns = resultado.columnas.map(columna => ({
      name: columna,
      label: columna
    }))
    tabla.value.rows = resultado.filas
    tabla.value.count = resultado.filas.length
    tabla.value.countPag = resultado.filas.length > 0 ? 1 : 0
    tabla.value.limit = Math.max(resultado.filas.length, 1)
    tablaKey.value += 1
  },
  { immediate: true, deep: true }
)
</script>
